import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/imgs/AB.png'
import _imports_1 from '@/assets/imgs/AD.png'
import _imports_2 from '@/assets/imgs/BA.png'
import _imports_3 from '@/assets/imgs/BC.png'
import _imports_4 from '@/assets/imgs/CB.png'
import _imports_5 from '@/assets/imgs/CD.png'
import _imports_6 from '@/assets/imgs/DA.png'
import _imports_7 from '@/assets/imgs/DC.png'


const _hoisted_1 = { class: "absolute z-10 w-full h-full flex justify-center items-center" }
const _hoisted_2 = {
  key: 0,
  class: "w-full",
  src: _imports_0,
  alt: "AB"
}
const _hoisted_3 = {
  key: 1,
  class: "w-full",
  src: _imports_1,
  alt: "AD"
}
const _hoisted_4 = {
  key: 2,
  class: "w-full",
  src: _imports_2,
  alt: "BA"
}
const _hoisted_5 = {
  key: 3,
  class: "w-full",
  src: _imports_3,
  alt: "BC"
}
const _hoisted_6 = {
  key: 4,
  class: "w-full",
  src: _imports_4,
  alt: "CB"
}
const _hoisted_7 = {
  key: 5,
  class: "w-full",
  src: _imports_5,
  alt: "CD"
}
const _hoisted_8 = {
  key: 6,
  class: "w-full",
  src: _imports_6,
  alt: "DA"
}
const _hoisted_9 = {
  key: 7,
  class: "w-full",
  src: _imports_7,
  alt: "DC"
}


export default /*#__PURE__*/_defineComponent({
  props: {
    direction: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.direction === 'AB')
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (__props.direction === 'AD')
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : (__props.direction === 'BA')
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : (__props.direction === 'BC')
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : (__props.direction === 'CB')
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : (__props.direction === 'CD')
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : (__props.direction === 'DA')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                  : (__props.direction === 'DC')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                    : _createCommentVNode("", true)
  ]))
}
}

})